import { EInternalPackageType, TAppState } from '../../types';
import { selectBuyPackageModalData } from './selectBuyPackageModalData';

export function selectPackageInternalType(state: TAppState): EInternalPackageType {
  const { internalType } = selectBuyPackageModalData(state);

  return internalType;
}
